import React from "react";
import { groupBy } from "lodash";
import {
  getFieldDate,
  getFieldText,
  getFieldName,
} from "./../../scripts/helperScripts";

function ServicesProvided({ recordedServices, exclusions = [] }) {
  let serviceItems = [];
  let filteredRecordedServices = recordedServices;

  if (exclusions !== undefined)
    filteredRecordedServices = recordedServices.filter((service) => {
      let isExcluded = false;
      exclusions.forEach((exclusion) => {
        if (getFieldName(service.ccx_serviceitem).includes(exclusion))
          isExcluded = true;
      });

      return !isExcluded;
    });

  serviceItems = groupBy(
    filteredRecordedServices.sort((a, b) => {
      const aCreatedOn = new Date(getFieldText(a.createdon));
      const bCreatedOn = new Date(getFieldText(b.createdon));
      if (aCreatedOn > bCreatedOn) return 1;
      if (aCreatedOn < bCreatedOn) return -1;
      return 0;
    }),
    "ccx_serviceitem['@name']"
  );

  return (
    <div className="container">
      <div className="row border-bottom border-top">
        <div className="col py-2">
          <b>Service Item</b>
        </div>
        <div className="col py-2">
          <b>Count</b>
        </div>
        <div className="col py-2">
          <b>Dates</b>
        </div>
      </div>
      {Object.keys(serviceItems).length > 0 ? (
        Object.keys(serviceItems).map((key) => (
          <div className="row border-bottom" key={key}>
            <div className="col py-2">{key}</div>
            <div className="col py-2">{serviceItems[key].length}</div>
            <div className="col py-2">
              {serviceItems[key].map((item) => (
                <div key={item.ccx_recorded_serviceid}>
                  {`${getFieldDate(item.ccx_starttime)}`}
                </div>
              ))}
            </div>
          </div>
        ))
      ) : (
        <div className="row border-top">
          <div className="col py-2">No Services Provided</div>
        </div>
      )}
      {/* <table className="table">
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(serviceItems).length > 0 ? (
            Object.keys(serviceItems).map((key) => (
              <tr key={key}>
                <td>{key}</td>
                <td>{serviceItems[key].length}</td>
                <td>
                  {serviceItems[key].map((item) => (
                    <div>
                      {`${getFieldDate(item.ccx_starttime)} - ${getFieldDate(
                        item.ccx_endtime
                      )}`}
                    </div>
                  ))}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={3}>No Services Provided</td>
            </tr>
          )}
          <tr>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table> */}
    </div>
  );
}

export default ServicesProvided;
